import { defineComponent as j, useModel as L, computed as l, openBlock as a, createBlock as o, unref as v, mergeProps as x, withModifiers as z, withCtx as F, createElementVNode as i, normalizeClass as s, createCommentVNode as c, createElementBlock as r, resolveDynamicComponent as A, toDisplayString as u, mergeModels as G } from "vue";
import { RevButtonBase as I } from "@ds/components/ButtonBase";
import { RevSpinner as U } from "@ds/components/Spinner";
import { RevTag as W } from "@ds/components/Tag";
import { omit as q } from "../../utils/omit.js";
import { tw as t } from "../../utils/tailwind.js";
import { DEFAULT_TAG_VARIANT as B } from "./Picker.constant.js";
const H = {
  key: 0,
  class: "flex w-full flex-col items-center whitespace-normal break-normal"
}, J = { class: "flex" }, K = {
  key: 1,
  class: "flex items-start whitespace-normal break-normal"
}, O = { class: "w-full" }, Q = { class: "flex items-baseline justify-between" }, X = "ml-auto body-2 text-static-default-low text-right shrink-0 max-w-[30%]", ae = /* @__PURE__ */ j({
  name: "RevPicker",
  inheritAttrs: !1,
  __name: "Picker",
  props: /* @__PURE__ */ G({
    description: { default: "" },
    disabled: { type: Boolean, default: !1 },
    prefix: { default: null },
    prefixProps: { default: () => ({}) },
    label: {},
    loading: { type: Boolean, default: !1 },
    to: { default: () => {
    } },
    tag: { default: "" },
    tracking: { default: () => ({}) },
    rel: { default: "" },
    alignment: { default: "center" },
    details: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const d = L(e, "modelValue"), P = l(() => e.to ? "link" : "button"), g = l(() => e.alignment === "center"), f = l(() => d.value && !e.disabled), V = l(() => d.value && e.disabled), S = l(() => {
      const n = t`bg-static-default-low focus-visible-outline-default-hi rounded-sm relative flex w-full flex-col justify-center py-12 no-underline motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out`, b = t`bg-static-default-low cursor-pointer hover:bg-static-default-low-hover`, m = t`border-action-default-low-pressed`, N = g.value ? t`px-12` : t`px-16`;
      return [
        !e.disabled && b,
        n,
        N,
        f.value && m
      ];
    }), E = l(() => {
      const n = t`rounded-sm absolute inset-0 motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out`, b = t`border-retina border-action-brand-low-pressed`, m = t`bg-static-default-low-disabled border-action-default-low-disabled text-static-default-low-disabled cursor-not-allowed focus:outline-none`;
      return [
        e.disabled && m,
        n,
        f.value ? b : "border border-action-brand-low",
        V.value && "border-2 border-action-brand-low-disabled"
      ];
    }), R = l(
      () => t`
  absolute left-0 top-1/2 -mt-12 flex w-full place-content-center ${e.disabled ? "text-action-default-hi-disabled" : "text-action-default-hi"}
`
    ), D = l(
      () => t`
  w-full ${e.loading ? "invisible" : ""}
`
    ), h = l(() => [
      t`body-1`,
      e.prefix && t`shrink`,
      e.disabled && t`text-static-default-hi-disabled`,
      d.value ? t`body-1-bold` : t`body-1`,
      f.value && t`text-action-default-hi-pressed`,
      !d.value && !e.disabled && t`text-action-default-hi`
    ]), w = l(() => [
      t`body-2 mt-4`,
      !e.disabled && t`text-static-default-mid`,
      e.disabled && t`text-static-default-hi-disabled`
    ]), k = l(() => q(e.prefixProps, "class")), y = l(() => [
      "mr-8",
      t`h-24 shrink-0`,
      !d.value && !e.disabled && t`text-action-default-hi`,
      f.value && t`text-action-default-hi-pressed`,
      e.disabled && t`text-action-default-hi-disabled`,
      e.prefixProps.class
    ]), M = l(
      () => t`
  absolute ${e.alignment === "left" ? "-top-10 right-12" : "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 -rotate-3"}
`
    ), C = l(() => typeof e.tag == "string" ? e.tag : e.tag?.label), T = l(
      () => typeof e.tag == "string" ? B : e.tag?.variant ?? B
    );
    function $() {
      d.value = !d.value;
    }
    return (n, b) => (a(), o(v(I), x(n.$attrs, {
      class: S.value,
      disabled: e.disabled,
      rel: e.rel,
      role: P.value,
      to: e.to,
      tracking: e.tracking,
      onClick: z($, ["prevent"])
    }), {
      default: F(() => [
        i("div", {
          class: s(R.value)
        }, [
          e.loading ? (a(), o(v(U), {
            key: 0,
            "aria-hidden": ""
          })) : c("", !0)
        ], 2),
        i("div", {
          class: s(E.value)
        }, null, 2),
        i("div", {
          class: s(D.value)
        }, [
          g.value ? (a(), r("div", H, [
            i("div", J, [
              (a(), o(A(e.prefix), x({ class: "" }, k.value, { class: y.value }), null, 16, ["class"])),
              i("span", {
                class: s(h.value)
              }, u(e.label), 3)
            ]),
            e.description ? (a(), r("div", {
              key: 0,
              class: s(w.value)
            }, u(e.description), 3)) : c("", !0)
          ])) : (a(), r("div", K, [
            (a(), o(A(e.prefix), x(k.value, { class: y.value }), null, 16, ["class"])),
            i("div", O, [
              i("div", Q, [
                i("p", {
                  class: s(["mr-4 text-left", h.value])
                }, u(e.label), 3),
                e.details ? (a(), r("p", {
                  key: 0,
                  class: s(X)
                }, u(e.details), 1)) : c("", !0)
              ]),
              e.description ? (a(), r("p", {
                key: 0,
                class: s(["text-left", w.value])
              }, u(e.description), 3)) : c("", !0)
            ])
          ]))
        ], 2),
        C.value ? (a(), o(v(W), {
          key: 0,
          class: s(M.value),
          label: C.value,
          variant: T.value
        }, null, 8, ["class", "label", "variant"])) : c("", !0)
      ]),
      _: 1
    }, 16, ["class", "disabled", "rel", "role", "to", "tracking"]));
  }
});
export {
  ae as default
};
